import moment from 'moment'

import { isLoginedToken, numbroUtil, limitPrecision, checkIsApp } from '~/common/js/utils'

// @TODO 规则，所有的通用属性和方法，属性和方法都会通过$$为前缀标识
export default {
  data() {
    return {
      __userAgent: null,
      // 设备信息
      systemInfo: {
        platform: '', // 客户端平台是哪些，一般表示为具体的入口渠道，如BitMart，wechat
        isApp: this.$route.query.platform === 'app', // 是否为APP平台渠道
        isBitMartApp: false, // 是否为APP平台渠道，且是BitMart相关产品平台
      },
    }
  },
  computed: {
    // ...mapState({
    //   $$locale: (state) => state.locale,
    // }),

    // 别名，向外暴露
    $$systemInfo() {
      return this.systemInfo
    },
  },
  filters: {
    dateFormatter(timestamp, format = 'YYYY-MM-DD HH:mm:ss') {
      if (!timestamp) return '-'
      return moment(timestamp).format(format)
    },
    amountFormatter(amount, limit = 8) {
      // 即将支持
      return numbroUtil(limitPrecision(amount, limit))
    },
  },

  methods: {
    // 2022-06-06
    // 获取用户系统信息
    // 先判断window.jsBridge，再判断userAgent，最后再兜底判断
    // platform: '', // 客户端平台是哪些，一般表示为具体的入口渠道，如BitMart，wechat
    // isApp: false, // 是否为APP平台渠道
    // isBitMartApp: false, // 是否为APP平台渠道，且是BitMart相关产品平台
    _setSystemInfo() {
      // @TODO 判断useragent
      const isApp = !!window.jsBridge || this.$route.query.platform === 'app'
      const platform = 'BitMart'

      this.systemInfo.platform = platform
      this.systemInfo.isApp = isApp
      this.systemInfo.isBitMartApp = isApp && platform === 'BitMart'
    },
    $$dateFormatter(timestamp, format = 'YYYY-MM-DD HH:mm:ss') {
      if (!timestamp) return '-'

      return moment(timestamp).format(format)
    },
    $$amountFormatter(amount, limit = 8) {
      // 即将支持
      return numbroUtil(limitPrecision(amount, limit))
    },
    // 判断一下是否在Bitmart APP
    $$isApp() {
      if (!process.client) return Promise.resolve(false)
      return Promise.resolve(checkIsApp())
    },
    // 是否为移动端
    $$isMobile() {
      return this.$$getUserAgent().then((env) => {
        return !!(env.os.isIOS || env.os.isAndroid)
      })
    },
    $$isIOS() {
      return this.$$getUserAgent().then((env) => {
        return !!env.os.isIOS
      })
    },
    $$isAndroid() {
      return this.$$getUserAgent().then((env) => {
        return !!env.os.isAndroid
      })
    },
    $$getUserAgent() {
      if (!process.client) return Promise.resolve(false)

      if (this.__userAgent) return Promise.resolve(this.__userAgent)

      return import('amfe-env').then((env) => {
        this.__userAgent = env
        return env
      })
    },
    // $$appendRouteParams(options) {
    //   if (options === '/') options = ''
    //   if (options.path === '/') options.path = ''

    //   if (typeof options === 'string') return options + '/' + this.$$locale

    //   // 移除falsiy值
    //   const falsiyList = [undefined, null, '']
    //   if (options.query) {
    //     Object.keys(options.query).forEach((key) => {
    //       if (falsiyList.indexOf(options.query[key]) >= 0) {
    //         delete options.query[key]
    //       }
    //     })
    //   }

    //   if (options.params) {
    //     Object.keys(options.params).forEach((key) => {
    //       if (falsiyList.indexOf(options.params[key]) >= 0) {
    //         delete options.params[key]
    //       }
    //     })
    //   }

    //   return {
    //     ...options,
    //     path: options.path + '/' + this.$$locale,
    //   }
    // },

    // 校验用户是否已登陆
    // 若已登陆，则直接执行目标逻辑，
    // 若未登陆则阻止执行目标逻辑，进入app端登陆流程，
    // 且app登陆完成后不会自动触发目标逻辑，必须用户重新执行上次的操作
    $$valideLoginThen(done) {
      if (!isLoginedToken()) {
        this.checkPlatformLogin(true)
      } else {
        done()
      }
    },
  },
  mounted() {
    // 设置系统信息
    this._setSystemInfo()
  },
}
